var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"size":"lg","hide-footer":"","id":"stock-suggestion-article"}},[_c('nav-component')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }